/**** mgt.Stops */

const config = {
  schema: 'mgt',
  table: 'Stops',
  title: 'Остановочные пункты',
  elemsOnPage: 20,
  fields: [
    {
      name: 'stop_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
      hide: true,
    },
    {
      name: 'stop_name',
      title: 'Наименование',
      type: 'text',
      required: true,
      hide: true,
    },
    {
      name: 'stop_lat',
      title: 'Широта',
      type: 'text',
      required: false,
      hide: true,
    },
    {
      name: 'stop_lon',
      title: 'Долгота',
      type: 'text',
      required: false,
      hide: true,
    },
    {
      title: 'Координаты',
      type: 'map',
      disableFilter: true,
      composite: {
        type: 'point_coords',
        lat: 'stop_lat',
        lon: 'stop_lon',
      },
    }
  ],
  defaultSort: {
    field: 'stop_id',
    direction: 'desc',
  },
  makeTitle: (elem: any, connections: { [key: string]: any }): string => {
    return `${elem['stop_name']}`;
  },
  makeAdditional: (elem: any, connections: { [key: string]: any }): string => {
    return '';
  }
};

export default config;
